import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Divider, Form, Steps } from "antd";
import { useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import PersonalInformation from "./PersonalInformation";
import Terms from "./Terms";
import Review from "./Review";
import DocumentsApplicant from "./DocumentsApplicant";
import { save, saveOutToken } from "../../../../features/auth/authSlice";
import {
  cleanApplicantObj,
  setApplicantObj,
} from "../../../../features/folder/folderSlice";
import { normalizeDateToLocalYear } from "../../../../utils";
import CareerHeader from "../../CareerHeader";
import ViewCard from "../ViewCard";
import dayjs from "dayjs";

export default function ApplicationStepper() {
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { applicantObj } = useSelector((state) => state.folder);
  const { activeObjJob } = useSelector((state) => ({
    activeObjJob: state.folder.activeObj["job"],
  }));
  const { tokenJobSeeker } = useSelector((state) => state.auth);
  const { docs } = useSelector((state) => state.folder);
  const formRef = useRef(null);

  const [current, setcurrent] = useState(0);

  const [fileUrlCv, setfileUrlCv] = useState("");
  const [fileUrlCover, setfileUrlCover] = useState("");
  const onFinish = async () => {
    if (!fileUrlCv) {
      toast.error("Cv is required");
      return;
    }
    const normalizedOrgObj = {
      ...applicantObj,
      docs: docs,
      japDob: normalizeDateToLocalYear(applicantObj?.japDob),
    };

    const res = await dispatch(
      saveOutToken({
        ...normalizedOrgObj,
        japCvFile: fileUrlCv,
        japCoverLetterFile: fileUrlCover,
        japJobId: activeObjJob?.jobId,
        url: "api/v1/applications/create",
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await navigate("/recruitment/career-list");
      await dispatch(cleanApplicantObj());
      await form.resetFields();
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  function handleNext() {
    setcurrent(current + 1);
  }

  function handleBack() {
    setcurrent(current - 1);
  }

  const steps = [
    {
      key: 0,
      title: "Personal Information",
      content: <PersonalInformation handleNext={handleNext} form={form} />,
    },

    {
      key: 2,
      title: "Documents",
      content: (
        <DocumentsApplicant
          handleBack={handleBack}
          handleNext={handleNext}
          form={form}
          fileUrlCv={fileUrlCv}
          setfileUrlCv={setfileUrlCv}
          fileUrlCover={fileUrlCover}
          setfileUrlCover={setfileUrlCover}
        />
      ),
    },
    {
      key: 2,
      title: "Terms",
      content: (
        <Terms handleBack={handleBack} handleNext={handleNext} form={form} />
      ),
    },

    {
      key: 3,
      title: "Review",
      content: (
        <Review
          handleBack={handleBack}
          form={form}
          fileUrlCv={fileUrlCv}
          fileUrlCover={fileUrlCover}
        />
      ),
    },
  ];

  const items = steps.map((item) => ({
    key: item.key,
    title: item.title,
    icon: item.icon,
  }));

  useEffect(() => {
    form.setFieldsValue({
      ...applicantObj,
      japDob: applicantObj?.japDob
        ? dayjs(new Date(applicantObj?.japDob))
        : null,
    });
  }, [applicantObj, form]);

  useEffect(() => {
    if (!activeObjJob?.jobId) {
      navigate("/recruitment/career-list");
    }
    if (!tokenJobSeeker) {
      toast.error("You need to login to proceed")
      navigate("/recruitment/login-seeker");
    }
  }, []);

  return (
    <div className="overflow-y-scroll flex flex-col  h-[100vh] w-full ">
      <CareerHeader hide={true} />
      <div className="lg:px-[22.5rem] px-3 ">
        <ViewCard />
        <div className="dark_card !h-auto flex !justify-start !items-start p-[2.5rem] mt-[1.5rem]">
          <div className="flex items-center justify-between w-full">
            <div className="text-lightBlack text-[1.5rem] font-[600] font-dmSans">
              {activeObjJob?.jobTitle}
            </div>
            <span
              className="inline-block w-fit max-w-full py-[.25rem] px-[.5rem] rounded-[2.1875rem] text-xs font-normal  
              bg-[#CDCDCD] text-lightBlack"
            >
              Draft
            </span>
          </div>

          <Divider />

          <Form
            onValuesChange={(data) => {
              dispatch(setApplicantObj({ ...applicantObj, ...data }));
            }}
            layout="vertical"
            ref={formRef}
            name="registration"
            onFinish={onFinish}
            scrollToFirstError
            form={form}
            // initialValues={applicantObj}
            className="w-full"
          >
            <div className="hidden lg:flex">
              <Steps
                className="w-full"
                current={current}
                labelPlacement="vertical"
                items={items}
              />
            </div>

            <div className="my-[1.5rem]">{steps[current].content}</div>
          </Form>
        </div>
      </div>
    </div>
  );
}
